"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Legend = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
function Legend({ render, title = 'Legenda', }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'card p-2', style: {
            width: "300px",
            pointerEvents: 'auto',
        }, children: [(0, jsx_runtime_1.jsx)("span", { className: "h6", children: title }), (0, jsx_runtime_1.jsx)("div", { children: render?.() })] }));
}
exports.Legend = Legend;
